import { createAction, props } from '@ngrx/store';

export const loadDownloadPopiDocs = createAction('[DownloadPopiDocs] Load DownloadPopiDocs', props<{ documentName: string }>());

export const loadDownloadPopiDocsSuccess = createAction('[DownloadPopiDocs] Load DownloadPopiDocs Success', props<{ reponse: any }>());

export const loadDownloadPopiDocsFailure = createAction(
  '[DownloadPopiDocs] Load DownloadPopiDocs Failure',
  props<{ error: Error | any }>()
);
